import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Col, Container } from "reactstrap";

const CustomBreadcrumb = ({ items,title }) => {

  const breadcrumbItems = [
    { label: "Home", link: `${process.env.PUBLIC_URL}/home`, active: false },
    { label: items, link: null, active: true },
  ];

  return (
    <div className='breadcrumb-bg'>
      <Container>
        <div  className="d-sm-flex flex-wrap align-items-center">
          <Col className='col-md-6 col-sm-6 d-aligns-center'>
            <h2 className='title'>
              <span>{title?title:'Blog'}</span>
            </h2>
          </Col>
          <div className="col-md-6 col-sm-6">
            <nav aria-label='breadcrumb' className='theme-breadcrumb p-0'>
              <Breadcrumb className='theme-breadcrumb bg-transparent mb-0'>
                {breadcrumbItems.map((item, index) => (
                  <BreadcrumbItem key={index} active={item.active}>
                    {item.active ? item.label : <Link to={item.link}>{item.label}</Link>}
                  </BreadcrumbItem>
                ))}
              </Breadcrumb>
            </nav>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CustomBreadcrumb;
